<template>
  <div v-if="isVisible" class="modal" @click="closeModal">
    <div class="modal__container" @click.stop>
      <div class="modal__close-icon" @click="closeModal">
        <IconCross color="#33333" size="25px" />
      </div>

      <div class="modal__content">
        <h2 class="modal__title">
          {{ $t('out_of_stock_modal.title') }}
        </h2>
        <p class="modal__message">
          {{ $t('out_of_stock_modal.message') }}
        </p>
        <button class="modal__action-button" @click="closeModal">
          {{ $t('close') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import IconCross from '~/components/icons/cross/Cross.vue'

export default {
  name: 'EmptyCartModal',
  components: {
    IconCross,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisible() {
      return this.visible
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    handleKeyDown(event) {
      if (event.key === 'Escape' && this.isVisible) {
        this.closeModal()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $rgba-light-shadow;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  &__container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px $rgba-dropdown-shadow;
    max-width: 400px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    padding: 20px;
  }

  &__close-icon {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
    cursor: pointer;
  }

  &__content {
    text-align: center;
    padding: 10px 0;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    color: $v4_color_primary;
    margin: 0 0 15px 0;
    line-height: 1.4;
  }

  &__message {
    font-size: 14px;
    color: $light_text_color;
    margin: 0 0 25px 0;
    line-height: 1.5;
  }

  &__action-button {
    background-color: $color_primary;
    color: white;
    border: none;
    padding: 12px 30px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s ease;
    width: 100%;

    &:hover {
      background-color: $light_text_color;
    }
  }

  @media (max-width: 480px) {
    &__container {
      margin: 20px;
      width: calc(100% - 40px);
    }

    &__title {
      font-size: 18px;
    }

    &__message {
      font-size: 15px;
    }
  }
}
</style>
